import { useCallback } from 'react';
import Button from 'components/Button';
import styles from './styles/PhotoGalleryAlertModal.module.scss';
import { usePhotoGalleryContainer } from '..';
import Clickable from '@/components/Clickable';

export default function PhotoGalleryPhotoNotForSale() {
  const [{}, { setAlertType }] = usePhotoGalleryContainer();

  const handleClose = useCallback(() => {
    setAlertType(null);
  }, [setAlertType]);

  return (
    <>
      <div className={styles.ModalHeading}>Photo Purchase Failed</div>
      <div className={styles.ModalBody}>
        One or more of the photos selected is no longer available for purchase. Please check back at a later time, or contact{' '}
        <Clickable href="mailto:support@scorebooklive.com?subject=Help with a photo purchase">support@scorebooklive.com</Clickable> for
        additional help.
      </div>
      <div className={styles.CopyrightButtons}>
        <Button label="Close" type="v2" className={styles.ModalCloseButton} onClick={handleClose} />
      </div>
    </>
  );
}
